<template>
  <v-hover v-slot="{ hover }">
    <v-row
      class="ml-2 my-2"
      align="center"
      @contextmenu.prevent="openMenu"
      style="cursor: pointer"
      no-gutters
    >
      <v-col cols="1">
        <v-avatar>
          <v-img :src="img_url" />
        </v-avatar>
      </v-col>
      <v-col cols="4">
        <v-row no-gutters>
          {{ serie }}
        </v-row>
        <v-row no-gutters>
          <span style="font-size: 18px">{{ varieta.nome }}</span>
        </v-row>
        <!-- <v-row no-gutters>
        {{ nome_colore }}
      </v-row> -->
      </v-col>
      <v-col cols="3">
        <span style="font-size: 18px">{{ nome_colore }}</span>
      </v-col>
      <v-col cols="3">
        <v-avatar size="30"
          ><v-img :src="avatar_fornitore(varieta.id_produttore)"
        /></v-avatar>
        {{ fornitore(varieta.id_produttore).nome }}
      </v-col>
      <v-col cols="1">
        <v-btn v-if="hover" color="red" icon @click="deleteItem"
          ><v-icon>mdi-delete</v-icon></v-btn
        >
      </v-col>
    </v-row>
  </v-hover>
</template>

<script>
export default {
  props: {
    varieta: Object,
    id_specie: String,
    series: Array,
  },
  data() {
    return {
      menu: false,
      nome_colore: "",
    };
  },
  mounted() {
    this.$store
      .dispatch("fetch_colore_by_id", this.varieta.id_colore)
      .then((res) => {
        this.nome_colore = res.nome;
      });
  },
  computed: {
    img_url() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/specie" +
        "/img_colore/" +
        this.varieta.id_colore + 
        "?t=" + this.varieta.md5_colore
      );
    },
    serie() {
      return this.series.find((serie) => serie.id == this.varieta.serie).nome;
    },
  },
  methods: {
    openMenu(e) {
      this.x = e.clientX;
      this.y = e.clientY;
      this.menu = true;
    },
    deleteItem() {
      this.$store.dispatch("elimina_varieta_specie", {
        id_specie: this.id_specie,
        id_varieta: this.varieta.id,
      });
    },
    fornitore(id_fornitore) {
      return this.$store.getters.get_fornitore_by_id(id_fornitore);
    },
    avatar_fornitore(id_fornitore) {
      return (
        process.env.VUE_APP_API_ROOT + "/fornitore/" + id_fornitore + "/avatar"
      );
    },
  },
};
</script>